import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=51bd154f&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=51bd154f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd154f",
  null
  
)

export default component.exports